import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { CryptoCurrencyIconSizeT } from './crypto-currency-icon.types'

const cryptoCurrencyImageSizeConfig: Record<CryptoCurrencyIconSizeT, FlattenSimpleInterpolation> = {
  base: css`
    width: 18px;
    height: 18px;
  `,
  lg: css`
    width: 24px;
    height: 24px;
  `,
}

export const CryptoCurrencyImage = styled.img<{ semiTransparent?: boolean; size?: CryptoCurrencyIconSizeT }>`
  flex-shrink: 0;
  opacity: ${({ semiTransparent }) => (semiTransparent ? 0.6 : 1)};

  ${({ size = 'base' }) => cryptoCurrencyImageSizeConfig[size]}
`
